import { getData } from '@/utils/request'

function getDefaultState () {
  return {
    id: null,
    name: null,
    cellphone: null,
    carNoPrefix: null,
    carBandIds: [],
    insuranceCompanyIds: []
  }
}

const state = getDefaultState()

const mutations = {
  RESET (state) {
    Object.assign(state, getDefaultState())
  }
}

const actions = {
  updateShopInfo ({ commit, state }) {
    return new Promise((resolve, reject) => {
      getData('curShop').then(response => {
        if (!response.data) {
          resolve(null)
        } else {
          Object.assign(state, response.data)
          resolve(response.data)
        }
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
